// extracted by mini-css-extract-plugin
export default {"productDescription":"s_-z","featuredDescription":"t_-z","description":"u_-z","more":"v_-z","descriptionSku":"w_-z"};